// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./src/taps.js";
import "./src/menu.js";
import "./src/alertbox.js";
import "./src/chart_graphs.js";
import "./src/accordion.js";
import "./src/darkMode.js";

// import "./src/layout.js";
// import "./src/materialflash.js";

document.addEventListener("turbo:load", function () {
  if (typeof grecaptcha !== "undefined" && grecaptcha) {
    grecaptcha.ready(function () {
      grecaptcha.render("recaptcha-container");
    });
  }
});
import "./controllers"
